import React from "react";

const NewPaymentMethod = () => {

  return (
    <div>
      <div class="col-md-6">
        <div class="card mb-4 mb-md-0">
          <button>
            +
          </button>
        </div>
      </div>
    </div>
  )
};

export default NewPaymentMethod;